import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCdprojektComponent } from './simple-icons-cdprojekt.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCdprojektComponent ],
    exports:      [ SimpleIconsCdprojektComponent ],
    bootstrap:    []
})
export class SimpleIconsCdprojektModule {}
